module.exports = __webpack_public_path__ + "img/logo.20720c56.png";